export const filterErrorFields = <T, K>(
    formValues: T,
    errors: K,
): Partial<T> => {
    return Object.keys(formValues).reduce((acc, key) => {
        if (!errors[key] || errors[key]?.type === 'required') {
            acc[key] = formValues[key];
        }
        return acc;
    }, {});
};
